<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">科目余额表</span>
		</div>
		<div class="margin-right-left margin-top no-print">
			<account-date-choose v-model="accountDate"/>
			<span class="range-sep">至</span>
			<DatePicker type="month" v-model="endMonth" format="YYYY-MM" placeholder="结束月份(可选)" :clearable="true" style="width: 130px; vertical-align: middle;"></DatePicker>
			<div class="float-right">
				<Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
				<Button icon="fa fa-download" @click="doExport">导出</Button>
				<Button icon="fa fa-print" @click="doPrint">打印</Button>
			</div>
		</div>
		<div class="h-panel-body">
			<div class="print-header">
				<div class="print-title">科目余额表</div>
				<div class="print-sub">
					<span>编制单位：{{currentAccountSets?currentAccountSets.companyName:''}}</span>
					<span>期间：{{printPeriod}}</span>
					<span>单位：元</span>
				</div>
			</div>
			<table class="balance" v-if="!showNumPrice">
				<thead class="header">
				<tr>
					<td rowspan="2">科目编码</td>
					<td rowspan="2">科目名称</td>
					<td colspan="2">期初余额</td>
					<td colspan="2">本期发生额</td>
					<td colspan="2">期末余额</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<template v-for="(item, index) in dataList">
					<tr v-if="item.code == null" :key="index" class="total-row">
						<td colspan="2" align="center"><b>{{item.name}}</b></td>
						<td align="right"><b>{{item.beginningDebitBalance|numFormat}}</b></td>
						<td align="right"><b>{{item.beginningCreditBalance|numFormat}}</b></td>
						<td align="right"><b>{{item.currentDebitAmount|numFormat}}</b></td>
						<td align="right"><b>{{item.currentCreditAmount|numFormat}}</b></td>
						<td align="right"><b>{{item.endingDebitBalance|numFormat}}</b></td>
						<td align="right"><b>{{item.endingCreditBalance|numFormat}}</b></td>
					</tr>
					<tr v-else :key="index">
						<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
						<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover primary-color" @click="openDetail(item)">{{item.name}}</span></td>
						<td align="right">{{item.beginningDebitBalance|numFormat}}</td>
						<td align="right">{{item.beginningCreditBalance|numFormat}}</td>
						<td align="right">{{item.currentDebitAmount|numFormat}}</td>
						<td align="right">{{item.currentCreditAmount|numFormat}}</td>
						<td :class="{tip:item.endingDebitBalance<0}" align="right">{{item.endingDebitBalance|numFormat}}</td>
						<td :class="{tip:item.endingCreditBalance<0}" align="right">{{item.endingCreditBalance|numFormat}}</td>
					</tr>
				</template>
					<tr v-if="!dataList.length">
						<td colspan="8" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
			<table class="balance" v-else>
				<thead class="header">
				<tr>
					<td rowspan="2">科目编码</td>
					<td rowspan="2">科目名称</td>
					<td colspan="2">期初余额</td>
					<td colspan="4">本期发生额</td>
					<td colspan="4">期末余额</td>
				</tr>
				<tr>
					<td>借方金额</td>
					<td>贷方金额</td>
					<td>借方数量</td>
					<td>借方金额</td>
					<td>贷方数量</td>
					<td>贷方金额</td>
					<td>借方数量</td>
					<td>借方金额</td>
					<td>贷方数量</td>
					<td>贷方金额</td>
				</tr>
				</thead>
				<tbody>
				<template v-for="(item, index) in dataList">
					<tr v-if="item.code == null" :key="index" class="total-row">
						<td colspan="2" align="center"><b>{{item.name}}</b></td>
						<td align="right"><b>{{item.beginningDebitBalance|numFormat}}</b></td>
						<td align="right"><b>{{item.beginningCreditBalance|numFormat}}</b></td>
						<td class="text-right" align="right"><b>{{item.currentDebitAmountNum|numFormat}}</b></td>
						<td class="text-right" align="right"><b>{{item.currentDebitAmount|numFormat}}</b></td>
						<td class="text-right" align="right"><b>{{item.currentCreditAmountNum|numFormat}}</b></td>
						<td class="text-right" align="right"><b>{{item.currentCreditAmount|numFormat}}</b></td>
						<td class="text-right" align="right"><b>{{item.endingDebitBalanceNum|numFormat}}</b></td>
						<td class="text-right" align="right"><b>{{item.endingDebitBalance|numFormat}}</b></td>
						<td class="text-right" align="right"><b>{{item.endingCreditBalanceNum|numFormat}}</b></td>
						<td class="text-right" align="right"><b>{{item.endingCreditBalance|numFormat}}</b></td>
					</tr>
					<tr v-else :key="index">
						<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
						<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover primary-color" @click="openDetail(item)">{{item.name}}</span></td>
						<td align="right">{{item.beginningDebitBalance|numFormat}}</td>
						<td align="right">{{item.beginningCreditBalance|numFormat}}</td>

					<td class="text-right" align="right">{{item.currentDebitAmountNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.currentDebitAmount|numFormat}}</td>
					<td class="text-right" align="right">{{item.currentCreditAmountNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.currentCreditAmount|numFormat}}</td>

					<td class="text-right" align="right">{{item.endingDebitBalanceNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.endingDebitBalance|numFormat}}</td>
					<td class="text-right" align="right">{{item.endingCreditBalanceNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.endingCreditBalance|numFormat}}</td>
				</tr>
				</template>
				<tr v-if="!dataList.length">
					<td colspan="12" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
		<SubjectDetailed ref="detailed" :subject="currentSubject" :accountDate="accountDate" :endAccountDate="detailEndDate"/>
	</app-content>
</template>

<script>
	import SubjectDetailed from '@/components/SubjectDetailed.vue';
	import moment from 'moment';
	import {mapState} from 'vuex';
	import {exportCsv} from '../../js/common/export-file';

	export default {
		name: "SubjectBalance",
		components: {SubjectDetailed},
		data() {
			return {
				dataList: [],
				accountDate: null,
				endMonth: null,
				showNumPrice: false,
				loading: false,
				currentSubject: null
			}
			},
			computed: {
			...mapState(['currentAccountSets']),
			printPeriod() {
			if (!this.accountDate) {
			return '';
			}
			let s = moment(this.accountDate).format('YYYY年MM月');
			if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
			s += ' 至 ' + moment(this.endMonth, 'YYYY-MM').format('YYYY年MM月');
			}
			return s;
			},
			//跨月查询时传递截止日期给科目详细弹窗，保持与列表口径一致
			detailEndDate() {
			if (this.endMonth && this.accountDate && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
			return moment(this.endMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
			}
			return null;
			}
			},
			watch: {
			accountDate() {
			this.loadList();
		},
		endMonth() {
			this.loadList();
		},
		showNumPrice() {
			this.loadList();
		}
		},
		methods: {
			loadList() {
				this.loading = true;
				let params = {
					accountDate: this.accountDate,
					showNumPrice: this.showNumPrice
				};
				if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
					params.endAccountDate = moment(this.endMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
				}
				this.$api.accountbook.loadSubjectBalance(params).then(({data}) => {
					this.dataList = data;
					this.loading = false;
				});
			},
			openDetail(item) {
				this.currentSubject = item;
				this.$nextTick(() => {
					this.$refs.detailed.open();
				});
			},
			doExport() {
				if (!this.dataList.length) {
					this.$Message.error('暂无数据可导出');
					return;
				}
				let headers, rows;
				if (!this.showNumPrice) {
					headers = ['科目编码', '科目名称', '期初借方', '期初贷方', '本期借方', '本期贷方', '期末借方', '期末贷方'];
					rows = this.dataList.map(item => [
						item.code, item.name,
						item.beginningDebitBalance, item.beginningCreditBalance,
						item.currentDebitAmount, item.currentCreditAmount,
						item.endingDebitBalance, item.endingCreditBalance
					]);
				} else {
					headers = ['科目编码', '科目名称', '期初借方', '期初贷方',
						'本期借方数量', '本期借方', '本期贷方数量', '本期贷方',
						'期末借方数量', '期末借方', '期末贷方数量', '期末贷方'];
					rows = this.dataList.map(item => [
						item.code, item.name,
						item.beginningDebitBalance, item.beginningCreditBalance,
						item.currentDebitAmountNum, item.currentDebitAmount,
						item.currentCreditAmountNum, item.currentCreditAmount,
						item.endingDebitBalanceNum, item.endingDebitBalance,
						item.endingCreditBalanceNum, item.endingCreditBalance
					]);
				}
				exportCsv('科目余额表-' + (this.accountDate ? moment(this.accountDate).format('YYYYMM') : '全部') + (this.endMonth ? '-' + moment(this.endMonth, 'YYYY-MM').format('YYYYMM') : ''), headers, rows);
			},
			doPrint() {
				window.print();
			}
		}
	}
</script>

<style scoped lang="less">
	.range-sep {
		margin: 0 8px;
		line-height: 30px;
		vertical-align: middle;
	}
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
